import { useFormikContext } from 'formik';

import { HypurrNetPoolPositionsTriggerFormValues } from '../../../domain';
import PriceReferenceSelect from '../common/price-reference/PriceReferenceSelect';

export default function PriceReferenceSelector() {
  const { values } = useFormikContext<HypurrNetPoolPositionsTriggerFormValues>();

  return (
    <PriceReferenceSelect
      chainIdentifier={String(values.chainId)}
      fieldName="volumeCurrencyAddress"
      label="Price Reference"
    />
  );
}
